import React from 'react';
import { VersionProvider } from './contexts/VersionContext';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';

function AppWrapper() {
  return (
    <ErrorBoundary>
      <VersionProvider>
        <App />
      </VersionProvider>
    </ErrorBoundary>
  );
}

export default AppWrapper;